import MenuIcon from '@mui/icons-material/Menu';
import type {SxProps} from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import {useNavigate} from 'react-router-dom';

type Props = {
    sx ?: SxProps;
};

const Hamburger = ({} : Props) : React.ReactElement => {
    const navigate = useNavigate();
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    // const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpenNavMenu = (event : React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return <Box sx={{flexGrow: 1}}>
        <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleOpenNavMenu}
            color="inherit"
        >
            <MenuIcon sx={{color: '#000'}}/>
        </IconButton>
        <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
        >
            <MenuItem onClick={() => {
                handleCloseNavMenu();
                navigate('/course-approvals');
            }}>
                <Typography textAlign="center">Course Approvals</Typography>
            </MenuItem>
            <MenuItem onClick={() => {
                handleCloseNavMenu();
                navigate('/my-digital-codes');
            }}>
                <Typography textAlign="center">My Digital Codes</Typography>
            </MenuItem>
            <MenuItem onClick={() => {
                handleCloseNavMenu();
                navigate('/my-rentals');
            }}>
                <Typography textAlign="center">My Rentals</Typography>
            </MenuItem>
            <MenuItem onClick={() => {
                handleCloseNavMenu();
                navigate('/sign-out');
            }}>
                <Typography textAlign="center">Sign-Out</Typography>
            </MenuItem>
        </Menu>
    </Box>;
};

export default Hamburger;
